import CopyTileSvg from '@assets/images/svg/copy-tile.svg';
import React from 'react';
import { View } from 'react-native';

export interface CopyTileIconProps {
    size?: number;
    color?: string;
}

/** Self-contained tile (grey rounded box + glyph baked in) for "copy to clipboard" buttons. */
export function CopyTileIcon({ size = 32, color = '#4D4D4D' }: Readonly<CopyTileIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CopyTileSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CopyTileIcon;
